import { useFormContext } from 'react-hook-form'
import { getServiceOrderTags } from 'services'
import {
  ComboBoxV3,
  TextareaV2,
  ButtonV2,
  FormItem,
  FormLabel,
  ModalV2,
  Icon,
  Tag,
} from 'components'

interface ConfirmScheduleModalProps {
  type: 'RESCHEDULED' | 'SCHEDULED'
  isNewSo: boolean
  onSubmit: () => void
  onClose: () => void
  isVisible: boolean
}

const ConfirmScheduleModal = ({
  isVisible,
  onSubmit,
  onClose,
  isNewSo,
  type,
}: ConfirmScheduleModalProps) => {
  const { register, watch, setValue, formState } = useFormContext()

  const { tags } = watch()

  return (
    <ModalV2.Root isOpen={isVisible} onClose={onClose}>
      <ModalV2.Content size="sm">
        <ModalV2.Title>
          {type === 'SCHEDULED'
            ? 'Confirmar agendamento'
            : 'Confirmar reagendamento'}
        </ModalV2.Title>
        {!isNewSo && (
          <FormItem>
            <FormLabel>Justificativa</FormLabel>
            <TextareaV2 {...register('note')} maxLength={5000} rows={5} />
          </FormItem>
        )}

        <FormItem>
          <FormLabel>Tags do agendamento (opcional)</FormLabel>
          <ComboBoxV3.Root
            valueKey="name"
            {...register('tags')}
            findOptions={getServiceOrderTags}
          >
            {({ unSelectedOptions }) => (
              <>
                <ComboBoxV3.Field value={tags} />
                {!!tags?.length && (
                  <>
                    <ComboBoxV3.Options>
                      {tags.map((tag) => (
                        <Tag key={tag.name}>
                          <span>{`${tag.name}`}</span>
                          <Icon
                            name="close-xlg"
                            width={8}
                            height={8}
                            onClick={() =>
                              setValue(
                                'tags',
                                tags?.filter((item) => item.name !== tag.name),
                                {
                                  shouldValidate: true,
                                },
                              )
                            }
                          />
                        </Tag>
                      ))}
                    </ComboBoxV3.Options>
                    <ButtonV2
                      size="md"
                      appearance="tertiary"
                      onClick={() =>
                        setValue('tags', [], {
                          shouldValidate: true,
                        })
                      }
                    >
                      <Icon name="delete" width={12} height={12} />
                      Remover tudo
                    </ButtonV2>
                  </>
                )}
                <ComboBoxV3.Group>
                  {unSelectedOptions?.map((option) => (
                    <ComboBoxV3.Option
                      key={option.id}
                      hasLabel={false}
                      onClick={() => {
                        setValue(
                          'tags',
                          [
                            ...(tags || []),
                            {
                              name: option.name,
                            },
                          ],
                          {
                            shouldValidate: true,
                          },
                        )
                      }}
                    >
                      {option.name}
                    </ComboBoxV3.Option>
                  ))}
                </ComboBoxV3.Group>
              </>
            )}
          </ComboBoxV3.Root>
        </FormItem>
        <ModalV2.Footer>
          <ModalV2.Close>
            <ButtonV2 appearance="tertiary">Cancelar</ButtonV2>
          </ModalV2.Close>
          <ButtonV2 onClick={onSubmit} disabled={!formState.isValid}>
            Salvar
          </ButtonV2>
        </ModalV2.Footer>
      </ModalV2.Content>
    </ModalV2.Root>
  )
}

export default ConfirmScheduleModal
